angular.
module("dx.webapp.logging").
config(function RavenInterceptorConfig(
	$httpProvider
) {
	"use strict";

	$httpProvider.interceptors.push("dxRavenInterceptor");
});
